import type { Optional } from 'chaika-common-types';
import type { PracticeContactViewModel } from 'chaika-types';

import { isDefined } from '@utils/isDefined';

export function isPracticeOfOrganization(
    practice: PracticeContactViewModel,
    organizationId: Optional<string>,
): boolean {
    return !isDefined(organizationId) || practice.organizationId === organizationId;
}
